import { createContext, useContext } from 'react';
import { AccountingType } from 'v2-types/order';

import { ListingsType, InsuranceCoverageInfo, Tab, Endorsements } from '../services/types';

export type updateType = { time: string, type:'error' | 'success' | 'info' | 'warning' | undefined, message:string}

type PolicyInfoContextType = {
  options: ListingsType;
  accounting: AccountingType[],
  setAccounting: (accountingData:AccountingType[]) => void,
  loading: boolean,
  latestUpdate: updateType | null,
  setLatestUpdate: ({ time, type, message }: updateType)=>void,
  isPolicyTabsLoading: boolean,
  tabs: Tab[],
  selectedTab: Tab | null,
  handleSelectTab: (tab: Tab) => void,
  insuranceInfo: InsuranceCoverageInfo | null,
  selectedTabIdRef: React.MutableRefObject<string>,
  endorsements: Endorsements,
  setEndorsements: React.Dispatch<React.SetStateAction<Endorsements>>
};

export const PolicyContext = createContext<PolicyInfoContextType | null>(null);

export const usePolicyInfoContext = () => useContext(PolicyContext) as PolicyInfoContextType;